import { datadogRum } from '@datadog/browser-rum';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';

/**
 * DataDogを初期化します。
 * REACT_APP_DATADOG_APPLICATION_IDが設定されていない場合は初期化しません。
 */
function init() {
  const {
    REACT_APP_DATADOG_APPLICATION_ID,
    REACT_APP_DATADOG_CLIENT_TOKEN,
    REACT_APP_DATADOG_SITE,
    REACT_APP_DATADOG_ENV,
    REACT_APP_DATADOG_SERVICE,
    REACT_APP_DATADOG_SESSION_SAMPLE_RATE,
    REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE,
    REACT_APP_DATADOG_DEFAULT_PRIVACY_LEVEL,
    REACT_APP_DATADOG_TRACING_SAMPLE_RATE,
    REACT_APP_API_URL,
  } = process.env;

  if (!REACT_APP_DATADOG_APPLICATION_ID) {
    return;
  }

  datadogRum.init({
    applicationId: REACT_APP_DATADOG_APPLICATION_ID,
    clientToken: REACT_APP_DATADOG_CLIENT_TOKEN,
    site: REACT_APP_DATADOG_SITE,
    env: REACT_APP_DATADOG_ENV,
    service: REACT_APP_DATADOG_SERVICE,
    sessionSampleRate: Number(REACT_APP_DATADOG_SESSION_SAMPLE_RATE || 100),
    sessionReplaySampleRate: Number(
      REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE || 100
    ),
    defaultPrivacyLevel: REACT_APP_DATADOG_DEFAULT_PRIVACY_LEVEL || 'allow',
    trackUserInteractions: true,
    allowedTracingOrigins: [REACT_APP_API_URL],
    tracingSampleRate: Number(REACT_APP_DATADOG_TRACING_SAMPLE_RATE || 100),
  });

  datadogRum.startSessionReplayRecording();
}

/**
 * DataDogのユーザー情報を更新します。
 */
function updateUser() {
  datadogRum.setUser({
    id: LocalStorageService.getUserId(),
    loginId: LocalStorageService.getLoginId(),
    fieldId: SessionStorageService.getFieldId(),
    roleCd: LocalStorageService.getRoleId(),
    operator: SessionStorageService.getOperatorId(),
  });
}

/**
 * DataDogのユーザー情報をクリアします。
 */
function clearUser() {
  datadogRum.clearUser();
}

export const datadog = {
  init,
  updateUser,
  clearUser,
};



// WEBPACK FOOTER //
// ./src/utilities/datadog.js